/* unplugin-vue-components disabled */import { render } from "./VaultInfo.vue?vue&type=template&id=83acea6e"
import script from "./VaultInfo.vue?vue&type=script&lang=js"
export * from "./VaultInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__